import BaseClusterGroupAdapter from './BaseClusterGroupAdapter'
import PointOfInterestAdapter from './PointOfInterestAdapter'

export default class PointsOfInterestClusterGroupAdapter extends BaseClusterGroupAdapter {
  static get ElementAdapter() {
    return PointOfInterestAdapter
  }
}
